// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"Editor_headerWrapper__2rEBR","header":"Editor_header__2Qcr4","container":"Editor_container__3rhfS"};